/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Platesheatexchangerefficiency3Inputs */



/**
* | output |
* | --- |
* | "Plate heat exchanger efficiency" |
*
* @param {Ahu_History_Key_Platesheatexchangerefficiency3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_platesheatexchangerefficiency3 = /** @type {((inputs?: Ahu_History_Key_Platesheatexchangerefficiency3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Platesheatexchangerefficiency3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Plate heat exchanger efficiency")
	return /** @type {LocalizedString} */ ("Efficacité echangeur à plaques")
});
export { ahu_history_key_platesheatexchangerefficiency3 as "ahu_history_key_platesHeatExchangerEfficiency" }